import { Col, Row } from 'reactstrap';

import CondicionalLookup from 'src/lookups/condicional';
import LocalidadeLookup from 'src/lookups/LocalidadeLookup';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { COLABORADOR_CAMPOS } from 'src/utils/constants';

import { hasSearchMatch } from './searchUtils';

const DisponibilidadeMudancasSection = ({ model, intl, campos, searchQuery }) => {
  if (!campos[COLABORADOR_CAMPOS.DISPONIBILIDADE_MUDANCA]) return null;

  const fieldMatches = (terms) => hasSearchMatch(searchQuery, terms);
  const sectionTerms = [
    intl.formatMessage({ id: 'disponibilidadeMudancas' }),
    intl.formatMessage({ id: 'disponibilidadeParaMudancas' }),
    intl.formatMessage({ id: 'localidades' }),
  ];

  if (!hasSearchMatch(searchQuery, sectionTerms)) return null;

  return (
    <CollapsibleSection title={intl.formatMessage({ id: 'disponibilidadeMudancas' })}>
      <Row>
        {fieldMatches([intl.formatMessage({ id: 'disponibilidadeParaMudancas' })]) && (
          <Col md={12}>
            <CondicionalLookup clearable model={model.getModel('disponibilidadeParaMudancas')} />
          </Col>
        )}
        {fieldMatches([intl.formatMessage({ id: 'localidades' })]) && (
          <Col md={12}>
            <LocalidadeLookup clearable model={model.getModel('localidadeDisponibilidade')} />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default DisponibilidadeMudancasSection;
